import { OLDEST_TIME } from '@customer/config/time';
import { useLocaleFormatter } from '@customer/shared/hooks/useLocaleFormatter';
import { AssetModel } from '@customer/store/apis/assetsApi';
import { DateTime } from 'luxon';
import { useMemo } from 'react';

interface UseAssetOverviewStatusProps {
  asset?: AssetModel;
}

export interface AssetOverviewErrors {
  levelOneFaultsActive: boolean;
  reporting: boolean;
  config: boolean;
  interactions: boolean;
}

export const useAssetOverviewErrors = ({
  asset,
}: UseAssetOverviewStatusProps): AssetOverviewErrors => {
  const { parseFromIso } = useLocaleFormatter();

  return useMemo(() => {
    if (asset) {
      const timeReported = parseFromIso(asset.ts ?? OLDEST_TIME);
      const timeConnected = parseFromIso(asset.tsRx ?? OLDEST_TIME);

      const sevenDaysAgo = DateTime.now().minus({ days: 7 });

      return {
        levelOneFaultsActive: asset.stsFltL1,
        reporting: timeReported < sevenDaysAgo || timeConnected < sevenDaysAgo,
        config: !asset.combCfgSts,
        interactions: asset.stsViOrGi,
      };
    }

    return {
      levelOneFaultsActive: false,
      reporting: false,
      config: false,
      interactions: false,
    };
  }, [asset, parseFromIso]);
};
